export default __webpack_public_path__ + "static/media/WCL9WK_autopilot.mp4-2000_QQHSUM.4a00e59a.mp4";